import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
// import Alert from '@material-ui/lab/Alert';
import { Card, makeStyles, CardContent, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
// import Snackbar from '@material-ui/core/Snackbar';
import SearchBox from '../../../components/table/SearchBox';
import DataTable from '../../../components/table/Table';
import FormDialog from '../../../components/table/FormDialog';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import NoofColleagueClients from '../../../modules/ultimate/view/IMCTable/noofcolleagueclients';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function ClientColleagueView() {
    const classes = useStyles();
    const history = useHistory();
    const [rows, setTotalReactPackages] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const corpName = userDetails.result && userDetails.result.data.firstName;
    const [allCorps, setAllCorps] = useState([]);
    let corpClientID = [];
    allCorps.map((item, index) => {
        if (item.corpClientName === corpName) {
            corpClientID.push(item);
        }
    });

    const clientID = corpClientID[0] && corpClientID[0].corpclientId;
    const [selectedCorp, setselectedCorp] = useState('');
    const [deletedata, setDeleteData] = useState(rows);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const handleClose = () => {
        setSuccessPop(false);
        setErrorPop(false);
    };
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    const headCells = [
        { id: 'colleagueName', label: 'Name' },
        { id: 'colleagueEmailId', label: 'Email' },
        { id: 'colleagueNumber', label: 'Phone' },
        { id: 'designation', label: 'designation' },
    ];
    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }
        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const getListData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague/${selectedImc}/${selectedCorp}?page=${page}&size=10`, axiosConfig)
            .then((response) => {
                setTotalReactPackages(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            });
    }
    useEffect(
        (data) => {

            if (userTeam != "ITeC Team") {
                if (userDomain) {
                    let JsonUserDomain = JSON.parse(userDomain)
                    setselectedImc(JsonUserDomain.tennantName);
                }
            }
            if (searchQuery && searchQuery.length > 2) {
                getSearchValueAdmin(searchQuery);
            }

            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${selectedImc}?page=${page}&size=100000&sort=corpclientId,desc`, axiosConfig)
                .then((response) => {
                    setAllCorps(response.data.content);
                })

            setTimeout(() => {
                axios
                    .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague/${selectedImc}/${clientID}?page=${page}&size=10&sort=corpColleagueId,desc`, {
                        headers: {
                            Authorization: bearerToken,
                        },
                    })
                    .then((response) => {
                        setTotalReactPackages(response.data.content);
                        setPageDetails(response.data);
                        setLoading(false);
                        if (response.data.first) {
                            setpreviousButton(true);
                            setnextButton(false);
                        } else if (response.data.last) {
                            setpreviousButton(false);
                            setnextButton(true);
                        } else {
                            setpreviousButton(false);
                            setnextButton(false);
                        }
                    })
                    .catch((error) => { })
            }, 1000)
        },
        [deletedata, userToken, page, selectedImc, selectedCorp, clientID]
    );

    const getSearchValueAdmin = (data) => {
        const inputData = userTeam === "Ultimate Client" ? clientID : selectedCorp
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague/${selectedImc}/${inputData}?search=${data}&page=${page}&size=10&sort=colleagueName,asc`, axiosConfig)
            .then((res) => {
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setTotalReactPackages([]);
                    }
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getListData();
    }

    const handleSearchQuery = (data) => {
        setSearchQuery(data);
        if (data && data.length > 2) {
            setPage(0);
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getListData();
        }
    };

    const handleSave = () => { };

    const handleDelete = (data) => {
        if (usertype !== "SUPERADMIN") {
            deleteIMCType(data, dbname);
        } else {
            deleteIMCType(data, selectedImc);
        }
    };


    const deleteIMCType = (data, value) => {
        setShowLoader(true);
        if (data.corpColleagueId) {
            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague/${value}/${data.corpColleagueId}`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    const { status } = response;
                    if (status === 200) {
                        const list = rows.filter((item) => item.corpColleagueId !== data.corpColleagueId);
                        setDeleteData({ rows: list });
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);
                    }
                })
                .catch((e) => {
                    setShowLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                });
        }
    }

    const navigate = () => {
        history.push('/menu/ClientColleagueCreate');
    };

    const allCorpOptions = (corpData) => {
        const OptionList = corpData.map((corp) => <option value={corp.corpclientId}>{corp.corpClientName}</option>);
        return OptionList;
    };

    const setCorp = (e) => {
        setselectedCorp(userTeam === "Ultimate Client" ? clientID : e.target.value);
        // setselectedCorp(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/intClient-colleague/${selectedImc}/${e.target.value}?page=${page}&size=10&sort=corpColleagueId,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setTotalReactPackages(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => { });
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;

    const back = () => {
        history.push('/menu');
    };

    return (
        <>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Colleague deleted successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}
            {showLoader ? (<LoaderPopUp showLoader={showLoader} handleClose={handleClose} />) : null}

            <Card className="custom-table mb10">
                <Grid container spacing={3} className="main-container w100i field-container1">
                    {userTeam === "ITeC Team" || userTeam === "Ultimate Client" ? (
                        ''
                    ) : (
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="sorp" shrink>
                                        Select Corp
                            </InputLabel>
                                    <Select
                                        native
                                        onChange={setCorp}
                                        value={selectedCorp}
                                        inputProps={{
                                            name: 'corpClientId',
                                        }}
                                        className="bottom"
                                    >
                                        <option value="">Select Corp</option>
                                        {allCorpOptions(allCorps)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                </Grid>
                {filteredRow.length > 0 ? (
                    <>
                        <div>
                            {userTeam === "ITeC Team" ? (
                                <NoofColleagueClients />
                            ) : (
                                    <CardContent className="card-title-display">
                                        <Grid item xs={12} sm={8}>
                                            <Typography className="card-title">Colleague List</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} className="card-search">
                                            <div className="search-field">
                                                <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                            </div>
                                            <div className="card-add-button">
                                                <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                                    Create Colleague
                                    </Button>
                                            </div>
                                        </Grid>
                                        <FormDialog row={[]} saveRow={handleSave} pageName="colleague" show="AddIcon" />
                                    </CardContent>
                                )}
                        </div>
                        <CardContent className="card-table-display">
                            <DataTable
                                rows={filteredRow}
                                headCells={headCells}
                                pageName="colleague"
                                saveRow={handleSave}
                                handleDelete={handleDelete}
                                action
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            />
                        </CardContent>
                    </>
                ) : (
                        <div>
                            {userTeam === "ITeC Team" ? (
                                <NoofColleagueClients />
                            ) : (
                                    <div>
                                        <CardContent className="card-title-display">
                                            <Grid item xs={12} sm={8}>
                                                <Typography className="card-title">Colleague List</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} className="card-search">
                                                <div className="search-field">
                                                    {searchQuery && (
                                                        <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                                    )}
                                                </div>
                                                <div className="card-add-button">
                                                    <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                                        Create Colleague
                                    </Button>
                                                </div>
                                            </Grid>
                                        </CardContent>
                                        <CardContent className="card-table-display">
                                            <div className={classes.noRecord}>
                                                <h1>No records to display</h1>
                                            </div>
                                        </CardContent>
                                    </div>
                                )}
                        </div>
                    )}
            </Card>
            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
                </Button>
        </>
    );
}

export default ClientColleagueView;
